// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dialog-container,
.analytics-dialog .mat-mdc-dialog-container .mdc-dialog__surface {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
  width: 100%;
  max-width: 65vh;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  font-family: "Raleway", Arial, Helvetica, sans-serif;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #f8f9fa;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
  min-height: 60px;
}
.analytics-header .analytics-title {
  flex: 1;
  min-width: 0;
}
.analytics-header .analytics-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.analytics-header .close-button {
  background: none !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #666;
  cursor: pointer;
  padding: 0 !important;
  margin-left: 16px;
  border-radius: 0 !important;
  min-width: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  --mat-mdc-button-persistent-ripple-color: transparent;
  --mat-mdc-button-ripple-color: transparent;
  --mdc-ripple-color: transparent;
  --mat-mdc-button-persistent-ripple-opacity: 0;
  --mat-mdc-button-ripple-opacity: 0;
}
.analytics-header .close-button:hover, .analytics-header .close-button:focus, .analytics-header .close-button:active {
  background: none !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.analytics-header .close-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.analytics-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  -webkit-overflow-scrolling: touch;
}
.analytics-content .mat-mdc-tab-group {
  height: 100%;
}
.analytics-content .mat-mdc-tab-group .mat-mdc-tab-body-wrapper {
  height: calc(100% - 48px);
}
.analytics-content .mat-mdc-tab-body-content {
  height: 100%;
  overflow-y: auto;
  padding: 20px 24px;
}

.time-period-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.time-period-selector label {
  font-weight: 600;
  color: #333;
  margin: 0;
  white-space: nowrap;
}
.time-period-selector .time-period-select {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  min-width: 120px;
  cursor: pointer;
}
.time-period-selector .time-period-select:focus {
  outline: 2px solid #333;
  outline-offset: 2px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.stats-grid .stat-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
}
.stats-grid .stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.stats-grid .stat-card .stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stats-grid .stat-card .stat-icon mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.stats-grid .stat-card .stat-content {
  flex: 1;
  min-width: 0;
}
.stats-grid .stat-card .stat-content .stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  margin-bottom: 4px;
}
.stats-grid .stat-card .stat-content .stat-label {
  font-size: 14px;
  color: #666;
  line-height: 1.2;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}
.charts-grid .chart-container {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}
.charts-grid .chart-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.charts-grid .chart-container h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.charts-grid .chart-container canvas {
  width: 100% !important;
  height: 300px !important;
  max-height: 300px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}
.loading-spinner mat-spinner {
  margin-bottom: 16px;
}
.loading-spinner p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .analytics-dialog-container {
    max-height: 100vh;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
    height: 100vh;
    width: 100vw;
  }
  .analytics-header {
    padding: 16px 20px;
    min-height: 56px;
  }
  .analytics-header .analytics-title h2 {
    font-size: 20px;
  }
  .analytics-header .close-button {
    min-width: 36px;
    min-height: 36px;
    margin-left: 12px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 16px 20px;
  }
  .time-period-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
  }
  .time-period-selector .time-period-select {
    width: 100%;
    min-width: unset;
  }
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .stats-grid .stat-card {
    padding: 16px;
  }
  .stats-grid .stat-card .stat-icon {
    width: 40px;
    height: 40px;
  }
  .stats-grid .stat-card .stat-icon mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .stats-grid .stat-card .stat-content .stat-value {
    font-size: 20px;
  }
  .stats-grid .stat-card .stat-content .stat-label {
    font-size: 12px;
  }
  .charts-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .charts-grid .chart-container {
    padding: 16px;
  }
  .charts-grid .chart-container h4 {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .charts-grid .chart-container canvas {
    height: 250px !important;
    max-height: 250px;
  }
}
@media (max-width: 480px) {
  .analytics-dialog-container {
    max-height: 100vh;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
    height: 100vh;
    width: 100vw;
  }
  .analytics-header {
    padding: 12px 16px;
    min-height: 52px;
  }
  .analytics-header .analytics-title h2 {
    font-size: 18px;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 12px 16px;
  }
  .charts-grid .chart-container {
    padding: 12px;
  }
  .charts-grid .chart-container canvas {
    height: 200px !important;
    max-height: 200px;
  }
}
@media (orientation: landscape) and (max-height: 600px) {
  .analytics-dialog-container {
    max-height: 95vh;
    max-width: 80vw;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 12px 16px;
  }
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }
  .stats-grid .stat-card {
    padding: 12px;
  }
  .stats-grid .stat-card .stat-icon {
    width: 36px;
    height: 36px;
  }
  .stats-grid .stat-card .stat-icon mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .stats-grid .stat-card .stat-content .stat-value {
    font-size: 18px;
  }
  .stats-grid .stat-card .stat-content .stat-label {
    font-size: 11px;
  }
  .charts-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }
  .charts-grid .chart-container {
    padding: 12px;
  }
  .charts-grid .chart-container h4 {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .charts-grid .chart-container canvas {
    height: 200px !important;
    max-height: 200px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .stat-card,
  .chart-container,
  .close-button {
    transition: none;
  }
}
@media (prefers-contrast: high) {
  .analytics-dialog-container {
    border: 2px solid #000;
  }
  .analytics-header {
    background: #f8f9fa;
    color: #000;
    border: 2px solid #000;
  }
  .stat-card,
  .chart-container {
    border: 2px solid #000;
  }
}
body.theme-dark .analytics-dialog-container {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}

body.theme-dark .analytics-header {
  background: #0d1b2e !important;
  color: #e2e8f0 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .analytics-header .analytics-title h2 {
  color: #e2e8f0 !important;
}
body.theme-dark .analytics-header .close-button {
  color: #94a3b8 !important;
}
body.theme-dark .analytics-header .close-button mat-icon {
  color: #94a3b8 !important;
}
body.theme-dark .analytics-header .close-button:hover {
  color: #e2e8f0 !important;
}

body.theme-dark .analytics-content {
  background: #1f2937 !important;
}

body.theme-dark .time-period-selector {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .time-period-selector label {
  color: #e2e8f0 !important;
}
body.theme-dark .time-period-selector .time-period-select {
  background: #0d1b2e !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
body.theme-dark .time-period-selector .time-period-select:focus {
  outline-color: #5ea1d8 !important;
}

body.theme-dark .stats-grid .stat-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
}
body.theme-dark .stats-grid .stat-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55) !important;
}
body.theme-dark .stats-grid .stat-card .stat-icon {
  background: #1e3a5f !important;
}
body.theme-dark .stats-grid .stat-card .stat-icon mat-icon {
  color: #5ea1d8 !important;
}
body.theme-dark .stats-grid .stat-card .stat-content .stat-value {
  color: #f1f5f9 !important;
}
body.theme-dark .stats-grid .stat-card .stat-content .stat-label {
  color: #94a3b8 !important;
}

body.theme-dark .charts-grid .chart-container {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
}
body.theme-dark .charts-grid .chart-container:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55) !important;
}
body.theme-dark .charts-grid .chart-container h4 {
  color: #e2e8f0 !important;
}

body.theme-dark .loading-spinner {
  color: #94a3b8 !important;
}
body.theme-dark .loading-spinner p {
  color: #94a3b8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-analytics/user-analytics.component.scss"],"names":[],"mappings":"AACA;;EAEE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,oDAAA;AAAF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AADF;AAGE;EACE,OAAA;EACA,YAAA;AADJ;AAGI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADN;AAKE;EACE,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,6CAAA;EACA,kCAAA;AAHJ;AAKI;EAGE,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AALN;AAQI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;AANN;;AAYA;EACE,OAAA;EACA,gBAAA;EACA,UAAA;EACA,iCAAA;AATF;AAWE;EACE,YAAA;AATJ;AAWI;EACE,yBAAA;AATN;AAaE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAbF;AAeE;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAdJ;AAgBI;EACE,uBAAA;EACA,mBAAA;AAdN;;AAoBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAjBJ;AAmBI;EACE,0CAAA;AAjBN;AAoBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAlBN;AAoBM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAlBR;AAsBI;EACE,OAAA;EACA,YAAA;AApBN;AAsBM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AApBR;AAuBM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AArBR;;AA4BA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,gCAAA;AAzBJ;AA2BI;EACE,0CAAA;AAzBN;AA4BI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA1BN;AA6BI;EACE,sBAAA;EACA,wBAAA;EACA,iBAAA;AA3BN;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AA9BF;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EACE,SAAA;EACA,eAAA;AA/BJ;;AAoCA;EACE;IACE,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;EAjCF;EAoCA;IACE,kBAAA;IACA,gBAAA;EAlCF;EAoCE;IACE,eAAA;EAlCJ;EAqCE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EAnCJ;EAqCI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAnCN;EAyCE;IACE,kBAAA;EAvCJ;EA2CA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,aAAA;EAzCF;EA2CE;IACE,WAAA;IACA,gBAAA;EAzCJ;EA6CA;IACE,0BAAA;IACA,SAAA;EA3CF;EA6CE;IACE,aAAA;EA3CJ;EA6CI;IACE,WAAA;IACA,YAAA;EA3CN;EA6CM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA3CR;EAgDM;IACE,eAAA;EA9CR;EAiDM;IACE,eAAA;EA/CR;EAqDA;IACE,0BAAA;IACA,SAAA;EAnDF;EAqDE;IACE,aAAA;EAnDJ;EAqDI;IACE,eAAA;IACA,mBAAA;EAnDN;EAsDI;IACE,wBAAA;IACA,iBAAA;EApDN;AACF;AAyDA;EACE;IACE,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;EAvDF;EA0DA;IACE,kBAAA;IACA,gBAAA;EAxDF;EA0DE;IACE,eAAA;EAxDJ;EA6DE;IACE,kBAAA;EA3DJ;EAgEE;IACE,aAAA;EA9DJ;EAgEI;IACE,wBAAA;IACA,iBAAA;EA9DN;AACF;AAoEA;EACE;IACE,gBAAA;IACA,eAAA;EAlEF;EAsEE;IACE,kBAAA;EApEJ;EAwEA;IACE,2DAAA;IACA,SAAA;EAtEF;EAwEE;IACE,aAAA;EAtEJ;EAwEI;IACE,WAAA;IACA,YAAA;EAtEN;EAwEM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtER;EA2EM;IACE,eAAA;EAzER;EA4EM;IACE,eAAA;EA1ER;EAgFA;IACE,2DAAA;IACA,SAAA;EA9EF;EAgFE;IACE,aAAA;EA9EJ;EAgFI;IACE,eAAA;IACA,kBAAA;EA9EN;EAiFI;IACE,wBAAA;IACA,iBAAA;EA/EN;AACF;AAqFA;EACE;;;IAGE,gBAAA;EAnFF;AACF;AAuFA;EACE;IACE,sBAAA;EArFF;EAwFA;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;EAtFF;EAyFA;;IAEE,sBAAA;EAvFF;AACF;AA2FA;EACE,8BAAA;EACA,yBAAA;AAzFF;;AA4FA;EACE,8BAAA;EACA,yBAAA;EACA,wDAAA;AAzFF;AA2FE;EACE,yBAAA;AAzFJ;AA4FE;EACE,yBAAA;AA1FJ;AA4FI;EACE,yBAAA;AA1FN;AA6FI;EACE,yBAAA;AA3FN;;AAgGA;EACE,8BAAA;AA7FF;;AAgGA;EACE,8BAAA;EACA,iDAAA;AA7FF;AA+FE;EACE,yBAAA;AA7FJ;AAgGE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA9FJ;AAgGI;EACE,iCAAA;AA9FN;;AAmGA;EACE,8BAAA;EACA,iDAAA;EACA,mDAAA;AAhGF;AAkGE;EACE,qDAAA;AAhGJ;AAmGE;EACE,8BAAA;AAjGJ;AAmGI;EACE,yBAAA;AAjGN;AAsGI;EACE,yBAAA;AApGN;AAuGI;EACE,yBAAA;AArGN;;AA0GA;EACE,8BAAA;EACA,iDAAA;EACA,mDAAA;AAvGF;AAyGE;EACE,qDAAA;AAvGJ;AA0GE;EACE,yBAAA;AAxGJ;;AA4GA;EACE,yBAAA;AAzGF;AA2GE;EACE,yBAAA;AAzGJ","sourcesContent":["// Analytics Dialog Container\n.analytics-dialog-container,\n.analytics-dialog .mat-mdc-dialog-container .mdc-dialog__surface {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 90vh;\n  width: 100%;\n  max-width: 65vh;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif;\n}\n\n// Header Section\n.analytics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: #f8f9fa;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n  min-height: 60px;\n\n  .analytics-title {\n    flex: 1;\n    min-width: 0;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: #333;\n      line-height: 1.2;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .close-button {\n    background: none !important;\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    color: #666;\n    cursor: pointer;\n    padding: 0 !important;\n    margin-left: 16px;\n    border-radius: 0 !important;\n    min-width: 24px;\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n    --mat-mdc-button-persistent-ripple-color: transparent;\n    --mat-mdc-button-ripple-color: transparent;\n    --mdc-ripple-color: transparent;\n    --mat-mdc-button-persistent-ripple-opacity: 0;\n    --mat-mdc-button-ripple-opacity: 0;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background: none !important;\n      background-color: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n      outline: none !important;\n    }\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      background: transparent !important;\n      background-color: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n}\n\n// Content Area\n.analytics-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  -webkit-overflow-scrolling: touch;\n\n  .mat-mdc-tab-group {\n    height: 100%;\n\n    .mat-mdc-tab-body-wrapper {\n      height: calc(100% - 48px);\n    }\n  }\n\n  .mat-mdc-tab-body-content {\n    height: 100%;\n    overflow-y: auto;\n    padding: 20px 24px;\n  }\n}\n\n// Time Period Selector\n.time-period-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n\n  label {\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  .time-period-select {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background: white;\n    font-size: 14px;\n    min-width: 120px;\n    cursor: pointer;\n\n    &:focus {\n      outline: 2px solid #333;\n      outline-offset: 2px;\n    }\n  }\n}\n\n// Stats Grid\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n\n  .stat-card {\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: box-shadow 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    .stat-icon {\n      width: 48px;\n      height: 48px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n\n      mat-icon {\n        color: #5ea1d8;\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .stat-content {\n      flex: 1;\n      min-width: 0;\n\n      .stat-value {\n        font-size: 24px;\n        font-weight: 700;\n        color: #333;\n        line-height: 1.2;\n        margin-bottom: 4px;\n      }\n\n      .stat-label {\n        font-size: 14px;\n        color: #666;\n        line-height: 1.2;\n      }\n    }\n  }\n}\n\n// Charts Grid\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 24px;\n\n  .chart-container {\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: box-shadow 0.2s ease;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    h4 {\n      margin: 0 0 16px 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n      text-align: center;\n    }\n\n    canvas {\n      width: 100% !important;\n      height: 300px !important;\n      max-height: 300px;\n    }\n  }\n}\n\n// Loading Spinner\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #666;\n\n  mat-spinner {\n    margin-bottom: 16px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .analytics-dialog-container {\n    max-height: 100vh;\n    max-width: 100vw;\n    margin: 0;\n    border-radius: 0;\n    height: 100vh;\n    width: 100vw;\n  }\n\n  .analytics-header {\n    padding: 16px 20px;\n    min-height: 56px;\n\n    .analytics-title h2 {\n      font-size: 20px;\n    }\n\n    .close-button {\n      min-width: 36px;\n      min-height: 36px;\n      margin-left: 12px;\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 16px 20px;\n    }\n  }\n\n  .time-period-selector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px;\n\n    .time-period-select {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n\n    .stat-card {\n      padding: 16px;\n\n      .stat-icon {\n        width: 40px;\n        height: 40px;\n\n        mat-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n      }\n\n      .stat-content {\n        .stat-value {\n          font-size: 20px;\n        }\n\n        .stat-label {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .charts-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n\n    .chart-container {\n      padding: 16px;\n\n      h4 {\n        font-size: 14px;\n        margin-bottom: 12px;\n      }\n\n      canvas {\n        height: 250px !important;\n        max-height: 250px;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .analytics-dialog-container {\n    max-height: 100vh;\n    max-width: 100vw;\n    margin: 0;\n    border-radius: 0;\n    height: 100vh;\n    width: 100vw;\n  }\n\n  .analytics-header {\n    padding: 12px 16px;\n    min-height: 52px;\n\n    .analytics-title h2 {\n      font-size: 18px;\n    }\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 12px 16px;\n    }\n  }\n\n  .charts-grid {\n    .chart-container {\n      padding: 12px;\n\n      canvas {\n        height: 200px !important;\n        max-height: 200px;\n      }\n    }\n  }\n}\n\n// Landscape Mode Responsive Popup\n@media (orientation: landscape) and (max-height: 600px) {\n  .analytics-dialog-container {\n    max-height: 95vh;\n    max-width: 80vw;\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 12px 16px;\n    }\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 12px;\n\n    .stat-card {\n      padding: 12px;\n\n      .stat-icon {\n        width: 36px;\n        height: 36px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      .stat-content {\n        .stat-value {\n          font-size: 18px;\n        }\n\n        .stat-label {\n          font-size: 11px;\n        }\n      }\n    }\n  }\n\n  .charts-grid {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 16px;\n\n    .chart-container {\n      padding: 12px;\n\n      h4 {\n        font-size: 14px;\n        margin-bottom: 8px;\n      }\n\n      canvas {\n        height: 200px !important;\n        max-height: 200px;\n      }\n    }\n  }\n}\n\n// Accessibility improvements\n@media (prefers-reduced-motion: reduce) {\n  .stat-card,\n  .chart-container,\n  .close-button {\n    transition: none;\n  }\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n  .analytics-dialog-container {\n    border: 2px solid #000;\n  }\n\n  .analytics-header {\n    background: #f8f9fa;\n    color: #000;\n    border: 2px solid #000;\n  }\n\n  .stat-card,\n  .chart-container {\n    border: 2px solid #000;\n  }\n}\n\n// ── Dark Mode ────────────────────────────────────────────\nbody.theme-dark .analytics-dialog-container {\n  background: #1f2937 !important;\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .analytics-header {\n  background: #0d1b2e !important;\n  color: #e2e8f0 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n  .analytics-title h2 {\n    color: #e2e8f0 !important;\n  }\n\n  .close-button {\n    color: #94a3b8 !important;\n\n    mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    &:hover {\n      color: #e2e8f0 !important;\n    }\n  }\n}\n\nbody.theme-dark .analytics-content {\n  background: #1f2937 !important;\n}\n\nbody.theme-dark .time-period-selector {\n  background: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n\n  label {\n    color: #e2e8f0 !important;\n  }\n\n  .time-period-select {\n    background: #0d1b2e !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n\n    &:focus {\n      outline-color: #5ea1d8 !important;\n    }\n  }\n}\n\nbody.theme-dark .stats-grid .stat-card {\n  background: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;\n\n  &:hover {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55) !important;\n  }\n\n  .stat-icon {\n    background: #1e3a5f !important;\n\n    mat-icon {\n      color: #5ea1d8 !important;\n    }\n  }\n\n  .stat-content {\n    .stat-value {\n      color: #f1f5f9 !important;\n    }\n\n    .stat-label {\n      color: #94a3b8 !important;\n    }\n  }\n}\n\nbody.theme-dark .charts-grid .chart-container {\n  background: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;\n\n  &:hover {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55) !important;\n  }\n\n  h4 {\n    color: #e2e8f0 !important;\n  }\n}\n\nbody.theme-dark .loading-spinner {\n  color: #94a3b8 !important;\n\n  p {\n    color: #94a3b8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
